import { render, staticRenderFns } from "./Asview.vue?vue&type=template&id=65efbbc0&scoped=true"
import script from "./Asview.vue?vue&type=script&lang=js"
export * from "./Asview.vue?vue&type=script&lang=js"
import style0 from "./Asview.vue?vue&type=style&index=0&id=65efbbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efbbc0",
  null
  
)

export default component.exports